/**
 * OVERRIDE FileView.jsx
 */
import FileView from '../../../../../components/Views/FileView';

export default FileView;
